import en from "./lang.en.json";
import nb from "./lang.nb.json";
import es from "./lang.es.json";
import tr from "./lang.tr.json";
import bg from "./lang.bg.json";
import ro from "./lang.ro.json";
import de from "./lang.de.json";
export default {
  en,
  nb,
  es,
  tr,
  bg,
  ro,
  de
};
